import { resolveUiLanguage, EnabledUiLanguage } from './languages';

// Browser-local presentation preference; never a company/accounting setting.
export const LANGUAGE_STORAGE_KEY = 'nimos.uiLanguage';

export function readLanguagePreference(): EnabledUiLanguage {
  try {
    return resolveUiLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
  } catch {
    return resolveUiLanguage(undefined);
  }
}

export function writeLanguagePreference(language: EnabledUiLanguage): void {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, resolveUiLanguage(language));
  } catch {
    // Storage is optional: the already-selected in-memory language remains usable.
  }
}
